import { DateStringValue } from '@mantine/dates';
import dayjs from 'dayjs';

export const handlePreviousMonthClick = (
  date: DateStringValue,
  setDate: (date: DateStringValue) => void
): void => {
  setDate(
    dayjs(date).subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
  );
};
